import styled from "styled-components";

const BlogPostCard = styled.div`
  width: calc(100vw - 3rem);
  padding: 1rem;

  background-image: linear-gradient(90deg, #000, #999);
  color: #fff;
`;

export default BlogPostCard;
